<!-- 
	This is the new product page, it uses the dashboard layout in: 
	"./layouts/Dashboard.vue" .
 -->

<template>
  <div>
    <div class="loading-spinner" v-if="isLoading">
      <div class="spinner"></div>
    </div>
    <div v-if="!isLoading">

      <!-- Header Background Image -->
      <div></div>
      <!-- / Header Background Image -->


      <!-- Steps and forms -->
      <div class="mx-auto m-50" style="max-width: 1200px;">

        <!-- Steps -->
        <!-- <div class="mb-50" style="max-width: 1200px;">

          <a-steps progress-dot v-model="step">

            <a-step title="1. Recipe Creation" />
            <a-step title="2. Rational" />
            <a-step title="3. SDS" />
          </a-steps>

        </div> -->
        <!-- / Steps -->

        <!-- Steps tabs and forms -->
        <div class="mb-50">

          <!-- Step 1 : Product Information -->
          <a-card v-if="step == 0" :bordered="false" class="header-solid" :bodyStyle="{ paddingTop: 0 }"
            :headStyle="{ paddingBottom: '0' }">



            <a-form :form="form" @submit="handleSubmit" :hideRequiredMark="true">
              <a-col :span="24">
                <a-form-item class="mb-10" label="Created By" :colon="false" required>
                  <a-input v-model="createdBy" placeholder="" read-only />
                </a-form-item>
              </a-col>
              <a-row :gutter="[24]">
                <a-col :span="24">
                  <a-form-item class="mb-10" label="Customer Name" :colon="false" required>
                    <a-select v-model="customerId" placeholder="Select customer">
                      <a-select-option v-for="customer in customerData" :key="customer.id" :value="customer.id">
                        {{ customer.customerName }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <a-form-item class="mb-10" label="Recipe Name" :colon="false" required>
                    <a-input v-model="recipeName" placeholder="Enter recipe name" />
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <a-form-item class="mb-10" label="Current Date" :colon="false" hidden>
                    <a-input :value="currentDateTime" @input="currentDateTime = $event" />
                  </a-form-item>
                </a-col>
              </a-row>
            </a-form>

            <template #title>
              <h5 class="mb-0">Recipe Creation</h5>
            </template>

            <!-- Product Information form -->
            <a-form :form="form" @submit="handleSubmit" :hideRequiredMark="true">
              <a-row :gutter="[24]">
                <a-col :span="12">
                  <a-form-item class="tags-field mb-10" label="Name" :colon="false">
                    <a-select mode="multiple" v-model="selectedTags" style="width: 100%" placeholder="eg. UREA (46) BULK">
                      <a-select-option v-for="classification in classificationData" :key="classification.id"
                        :value="classification.component_Name">
                        {{ classification.component_Name }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="[24]">
                <a-col :span="24">
                  <a-form-item class="mb-10" label="Selected Recipe Items (Percentage)" :colon="false">
                    <table cellpadding="5">
                      <tr v-for="value in selectedTags">
                        <td>
                          {{ getDetailsByComponentName(value).component_Name }}
                        </td>
                        <td>
                          <a-input :id="getDetailsByComponentName(value).component_Name + '-ConcentrationId'"
                            placeholder="eg. 7.4" :value="getDetailsByComponentName(value).percentage"
                            @input="handleInput($event, value)" @change="calculateSumOfBlend()" type="number" />
                        </td>
                        <td>
                          <a-input read-only :value="getDetailsByComponentName(value).oralCalc" />
                        </td>
                        <td>
                          <a-input read-only :value="getDetailsByComponentName(value).dermalCalc" />
                        </td>
                        <td>
                          <a-input read-only :value="getDetailsByComponentName(value).inhalationCalc" />
                        </td>
                      </tr>
                    </table>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-form>
            <!-- <a-row :gutter="[24]">
                <a-col :span="24" v-if="selectedTags.length">
                  <h4>Totals</h4>
                </a-col>
              </a-row> -->
            <a-row :gutter="[24]" class="calculation-section">
              <a-col :span="24" v-if="selectedTags.length">
                <a-form :form="form" @submit="handleSubmit" :hideRequiredMark="true">
                  <a-row :gutter="[24]">
                    <a-col :span="6" v-if="selectedTags.length">
                      <a-form-item class="tags-field mb-10" label="Sum of blend" :colon="false" :span="3">
                        <a-input id="sumOfBlend" v-model="sumOfBlend" read-only />
                      </a-form-item>
                    </a-col>
                    <a-col :span="6" v-if="selectedTags.length">
                      <a-form-item class="tags-field mb-10" label="ATE MIX (Oral)" :colon="false">
                        <a-input id="ateMixOral" v-model="ateMixOral" read-only />
                      </a-form-item>
                    </a-col>
                    <a-col :span="6" v-if="selectedTags.length">
                      <a-form-item class="tags-field mb-10" label="TOTAL ATE (Oral)" :colon="false">
                        <a-input id="totalATEMixOral" v-model="totalATEMixOral" read-only />
                      </a-form-item>
                    </a-col>
                    <a-col :span="6" v-if="selectedTags.length">
                      <a-form-item class="tags-field mb-10" label="ATE MIX (Dermal)" :colon="false">
                        <a-input id="ateMixDermal" v-model="ateMixDermal" read-only />
                      </a-form-item>
                    </a-col>
                    <a-col :span="6" v-if="selectedTags.length">
                      <a-form-item class="tags-field mb-10" label="TOTAL ATE (Dermal)" :colon="false">
                        <a-input id="totalATEMixDermal" v-model="totalATEMixDermal" read-only />
                      </a-form-item>
                    </a-col>
                    <a-col :span="6" v-if="selectedTags.length">
                      <a-form-item class="tags-field mb-10" label="ATE MIX (Inhalation)" :colon="false">
                        <a-input id="ateMixInhalation" v-model="ateMixInhalation" read-only />
                      </a-form-item>
                    </a-col>
                    <a-col :span="6" v-if="selectedTags.length">
                      <a-form-item class="tags-field mb-10" label="TOTAL ATE (Inhalation)" :colon="false">
                        <a-input id="totalATEMixInhalation" v-model="totalATEMixInhalation" read-only />
                      </a-form-item>
                    </a-col>
                  </a-row>
                </a-form>
              </a-col>
            </a-row>
            <a-row :gutter="[24]">
              <a-col :span="12">
              </a-col>
              <a-col :span="12" class="text-right">
                <a-button type="primary" html-type="submit" :disabled="isSaving" :loading="isSaving" @click="saveRecipe()"
                  class="px-25">Save</a-button>
              </a-col>
            </a-row>

            <!-- This is where I removed steps -->

          </a-card>

        </div>
        <!-- / Steps tabs and forms -->

      </div>
      <!-- / Steps and forms -->

    </div>
  </div>
</template>

<script>

import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import { quillEditor } from 'vue-quill-editor'

// Available tags.
//const tags = ['UREA (46) BULK', 'LAN 289', 'CAN 27', 'Calcium Carbonate', 'AMS 04 GRAN', 'MAP  BULK', "KCL GRAN BULK", "K2SO4 (SOP)", "KNO310", "BRIMSTONE", "ZN 20/ZN40", "ZnSO4", "KORREL BOOR4", "Arborite", "QDROP KS", "CaNO3", "MgNO3", "MgSO4", "Supers 1412", "Microlife", "Calcium sulfate6", "CALMAG5", "FILLER", "SELCOTE8", "MB", "CMB", "ACTIFYN", "MAP TECH", "MKP", "COPSUL", "AMFIX RD 52", "Nutrisphere", "Avail", "Green Boost", "Green Optimizer"];

const classificationData = [];

const customerData = [];

export default {
  components: {
    quillEditor,
  },
  data() {
    return {

      // Active button for the "User Profile" card's radio button group.
      profileHeaderBtns: 'overview',
      form: this.$form.createForm(this),
      loggedInUser: '',
      currentDateTime: '',
      recipeId: null,
      recipeName: '',
      createdBy: '',
      customerId: [],
      ateMixOral: 0,
      totalATEMixOral: 0,
      ateMixDermal: 0,
      totalATEMixDermal: 0,
      ateMixInhalation: 0,
      totalATEMixInhalation: 0,
      sumOfBlend: 0,
      isLoading: false,
      isSaving: false,
      // Current active step.
      step: 0,
      userData: [],

      // Selected tags.
      selectedTags: [],

      classificationData,

      customerData,

      // Form object.
      form: this.$form.createForm(this, { name: 'newProduct' }),

      // Quill editor html content.
      quillContent: '<p>Some initial <strong>bold</strong> text</p>',

      // Quill editor options.
      quillOptions: {
        modules: {
          toolbar: [
            [{ 'header': [1, 2, 3, false] }],
            ['bold', 'italic', 'underline'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }, 'link'],
            ['clean'],
          ]
        },
      }

    }
  },

  mounted() {
    const now = new Date();
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    const day = now.getDate().toString().padStart(2, '0');
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');

    this.currentDateTime = `${year}-${month}-${day} ${hours}:${minutes}`;
  },

  methods: {
    handleInput(event, componentName) {
      const componentDetail = this.getDetailsByComponentName(componentName);
      componentDetail.percentage = event.target.value;
      this.calculateSumOfBlend();
    },
    async generateDocumentRational() {
      this.$store.dispatch("WordDocs/getRational");
    },

    async generateDocumentSDS() {
      this.$store.dispatch("WordDocs/getSDS");
    },

    async generateDocumentLabel() {
      this.$store.dispatch("WordDocs/getLabel");
    },

    getDetailsByComponentName(componentName) {
      return this.classificationData.find(item => item.component_Name === componentName) || {};
    },

    calculateSumOfBlend() {
      let total = 0;
      for (const value of this.selectedTags) {
        let valueArray = this.getDetailsByComponentName(value);
        let percentValue = parseFloat(valueArray.percentage);
        if (!isNaN(percentValue)) {
          total += percentValue;
        }
      }
      this.sumOfBlend = total;
      this.calculateDerivedOralValue();
      this.calculateDerivedDermalValue();
      this.calculateDerivedInhaleValue();
    },


    calculateDermalSum() {
      let dermalSum = 0;

      for (const value of this.selectedTags) {
        let valueArray = this.getDetailsByComponentName(value);
        if (valueArray.dermalCalc !== 0 && !isNaN(valueArray.percentage)) { // Make sure you handle non-zero values
          dermalSum += valueArray.percentage / valueArray.dermalCalc;
        }
      }

      this.ateMixDermal = dermalSum.toFixed(6);
      return dermalSum.toFixed(6);
    },

    calculateOralSum() {
      let oralSum = 0;

      for (const value of this.selectedTags) {
        let valueArray = this.getDetailsByComponentName(value);
        if (valueArray.oralCalc != 0 && !isNaN(valueArray.percentage)) { // Make sure you handle non-zero values
          oralSum += valueArray.percentage / valueArray.oralCalc;
        }
      }
      this.ateMixOral = oralSum.toFixed(6);
      return oralSum.toFixed(6);
    },

    calculateInhaleSum() {
      let inhaleSum = 0;

      for (const value of this.selectedTags) {
        let valueArray = this.getDetailsByComponentName(value);
        if (valueArray.inhalationCalc != 0 && !isNaN(valueArray.percentage)) { // Make sure you handle non-zero values
          inhaleSum += valueArray.percentage / valueArray.inhalationCalc;
        }
      }
      this.ateMixInhalation = inhaleSum.toFixed(6);
      return inhaleSum.toFixed(6);
    },

    calculateDerivedDermalValue() {
      const dermalSum = this.calculateDermalSum(); // Calculate dermalSum
      let fillerPercentage = 0;
      let derivedValue = 0;

      // Find the filler index
      const fillerIndex = this.selectedTags.findIndex(item => item === "FILLER");

      if (fillerIndex != -1) {
        fillerPercentage = this.getDetailsByComponentName("FILLER").percentage;
      }

      if (dermalSum != 0 && !isNaN(dermalSum)) {
        derivedValue = (100 - (isNaN(parseFloat(fillerPercentage)) ? 0 : parseFloat(fillerPercentage))) / dermalSum;
      }

      this.totalATEMixDermal = derivedValue.toFixed(6);
    },

    calculateDerivedOralValue() {
      const oralSum = this.calculateOralSum(); // Calculate dermalSum
      let fillerPercentage = 0;
      let derivedValue = 0;

      // Find the filler index
      const fillerIndex = this.selectedTags.findIndex(item => item === "FILLER");

      if (fillerIndex != -1) {
        fillerPercentage = this.getDetailsByComponentName("FILLER").percentage;
      }

      if (oralSum != 0 && !isNaN(oralSum)) {
        derivedValue = (100 - (isNaN(parseFloat(fillerPercentage)) ? 0 : parseFloat(fillerPercentage))) / oralSum;
      }

      this.totalATEMixOral = derivedValue.toFixed(6);
    },

    calculateDerivedInhaleValue() {
      const inhaleSum = this.calculateInhaleSum(); // Calculate dermalSum
      let fillerPercentage = 0;
      let derivedValue = 0;

      // Find the filler index
      const fillerIndex = this.selectedTags.findIndex(item => item === "FILLER");

      if (fillerIndex != -1) {
        fillerPercentage = this.getDetailsByComponentName("FILLER").percentage;
      }

      if (inhaleSum != 0 && !isNaN(inhaleSum)) {
        derivedValue = (100 - (isNaN(parseFloat(fillerPercentage)) ? 0 : parseFloat(fillerPercentage))) / inhaleSum;
      }

      this.totalATEMixInhalation = derivedValue.toFixed(6);
    },

    async saveRecipe() {
      this.isSaving = true;
      let classificationsArray = [];

      for (let key in this.selectedTags) {
        let classificationInfo = this.getDetailsByComponentName(this.selectedTags[key]);
        let classificationId = classificationInfo['id'];
        let classificationName = classificationInfo['component_Name'];
        let concentration = document.getElementById(classificationInfo['component_Name'] + '-ConcentrationId').value;
        let classificationData = {
          classificationId: classificationId,
          classificationName: classificationName,
          concentration: concentration
        };
        classificationsArray.push(classificationData);
      }

      let dataArray = [{
        recipeName: this.recipeName,
        createdBy: this.createdBy,
        customerId: this.customerId,
        ateMixOral: this.ateMixOral,
        totalATEMixOral: this.totalATEMixOral,
        ateMixDermal: this.ateMixDermal,
        totalATEMixDermal: this.totalATEMixDermal,
        ateMixInhalation: this.ateMixInhalation,
        totalATEMixInhalation: this.totalATEMixInhalation,
        sumOfBlend: this.sumOfBlend,
        classifications: classificationsArray
      }]

      this.$store.dispatch("recipes/addNewRecipe", dataArray[0]).then(() => {
        this.recipeId = this.Recipe[0].id;
        this.isSaving = false;
        this.$router.push('/Recipe/UpdateRecipe/' + this.recipeId);
      }).catch((error) => {
        alert('Something went wrong, try again');
        console.error(error)
        this.isSaving = false;
      });
    },

    // Handles input validation after submission.
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values);
        }
      });
    },

    isAdmin() {
      return this.admin;
    }
  },
  computed: {
    classifications: {
      get() {
        return this.$store.state.classifications.classifications;
      },
    },
    user: {
      get() {
        return this.$store.state.user.dashboardUserInfo;
      }
    },

    Customers: {
      get() {
        return this.$store.state.Customers.Customers;
      }
    },

    Recipe: {
      get() {
        return this.$store.state.recipes.recipe;
      }
    },
    // oralCalculated: {
    //   get() {
    //     console.log('here we go')
    //     console.log(this)
    //     return this.oralCalc;
    //   }
    // }
    admin: {
      get() {
        return this.$store.getters['user/isAdmin'];
      }
    },
  },
  created() {
    this.$store.dispatch('user/getUserInfo').then(() => {
      this.userData = this.user;
      this.createdBy = this.userData.firstName + " " + this.userData.lastName;
    })
    this.$store.dispatch('classifications/getAll').then((res) => {
      this.classificationData = this.$store.state.classifications.classifications;
      //console.log("data1" + this.$store.state.classifications.classifications);
    }).catch(error => {
      console.error(error)
    })

    //console.log('ID:', this.$route.params.id);
    this.$store.dispatch('Customers/getAll').then(() => {

      if (this.isAdmin()) {
        this.customerData = this.Customers;
      } else {
        this.customerData = this.Customers.filter(customer => customer.id == this.user.customerId)
      }
      //console.log("customerData", this.customerData); // Corrected console log
    });

    // store.dispatch('transactions/getAll').then((res) => {
    //   transactions.value = res;
    //   console.log('data below')
    //   console.log(transactions)
    // }).catch(error => {
    //   console.error(error)
    // })

  }
}

</script>

<style lang="scss">
.avatar {
  width: 50px;
  height: 50px;
  margin-top: 10px;
}

.loading-spinner {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner {
  border: 16px solid #f3f3f3;
  border-top: 16px solid #3498db;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>